import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient } from "aws-amplify/api";
import { getRemainingKrunshCredits as getRemainingKrunshCreditsQuery } from "@/graphql/queries";

const client = generateClient();

export const remainingKrunshCreditsState = create<State<number>>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const getRemainingKrunshCreditsIsloading = () =>
  remainingKrunshCreditsState.setState(() => ({
    isLoading: true,
    data: null,
    error: null,
  }));
export const getRemainingKrunshCreditsIsError = (error: Error) =>
  remainingKrunshCreditsState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
  }));
export const getRemainingKrunshCreditsIsSuccess = (data: number) =>
  remainingKrunshCreditsState.setState(() => ({
    data,
    isLoading: false,
    error: null,
  }));

export const getRemainingKrunshCredits = async () => {
  getRemainingKrunshCreditsIsloading();

  try {
    const { data } = await client.graphql({
      query: getRemainingKrunshCreditsQuery,
    });

    getRemainingKrunshCreditsIsSuccess(data.getRemainingKrunshCredits);
  } catch (e) {
    const errorMessage =
      e instanceof Error
        ? e.message
        : "failed to query getRemainingKrunshCredits";
    getRemainingKrunshCreditsIsError(Error(errorMessage));
  }
};
